import WRAP from "WRAP-JS";

/* eslint-disable */
WRAP.Data.Controller.EXPO_ObservationDBExt = (function(){

    function update(data) {
        var m = data.control.master, t = data.control.time&&data.control.time.data, info = data.control.info;
        if (!m || !t || !info)
            return;
        var geo = {
            type: "FeatureCollection",
            features: []
        };

        for (var i = 0 ; i < m.length ; i++) {
            var item = m[i];
            var f = {
                type:"Feature",
                geometry: {
                    type:"Point",
                    coordinates:[item.master.LOND,item.master.LATD]
                },
                properties: {}
            }
            for ( var key in item.master )
                f.properties[key] = item.master[key];
            var prop = t[item.id];
            if (prop) {
                for (var key in prop)
                    f.properties[key] = prop[key];
                    f.properties.prioritized = m[i].prioritized;
                    f.properties.popup = m[i].popup;　//popup windowの表示状態をpropertiesに反映させる
                var label = f.properties.label = {};
                var e = info.ELEMS; 
                for (var l in e) {
                    var value = prop[l];
                    if (value === undefined)
                        continue;
                    var unit = e[l].UNIT;
                    if (typeof (unit) == 'object') {
                        if (unit[value] === undefined) {
                            label[l] = {
                                en:(e[l].ENAME || l)+': '+value,
                                ja:(e[l].JNAME || l)+': '+value
                            }
                        }
                        else {
                            label[l] = {
                                en:(e[l].ENAME || l)+': '+unit[value].ENAME,
                                ja:(e[l].JNAME || l)+': '+unit[value].JNAME
                            }
                        }
                    }
                    else {
                        label[l] = {
                            en:(e[l].ENAME || l)+': '+value+(unit.ENAME||(' '+unit)),
                            ja:(e[l].JNAME || l)+': '+value+(unit.JNAME||(' '+unit))
                        }
                    }
                    const regex = /-999999999|-1111111111|-11111|-9999/g;
                    label[l].en = label[l].en.replace(regex, '-');
                    label[l].ja = label[l].ja.replace(regex, '-');
                }
            }
/*            
            if ( prop.valid_time ) {
                var vt = new WRAP.Core.DateTime(item.prop);
                label.valid_time = {
                    en:vt.text('Time: MM/DD HH:MM'),
                    ja:vt.text('時間: MM月DD日HH時MM分')
                }
            }
*/                

            geo.features.push(f);
        }
            
        data.control.state.retained = geo;
        data.control.state.status = null;
        data.control.state.revision++;
        data._update('data', data.control.state);
        data._inspector(data.source.data);
        for (var i = 0 ; i < data.source.data.inspector.completed.length ; i++)
            data.source.data.inspector.completed[i](data.retained.data);
    }

    function setMaster(data, master) {
        if ( !master )
            console.error("EXPO_ObservationDB Error: invalid master data");
        data.control.master = [];
        var priority = (data.controller_conf && data.controller_conf.priority) || [];
        for (var i = 0 ; i < priority.length ; i++) {
            var id = priority[i];
            var m = master[id];
            if (m)
                data.control.master.push({id:id, master:m, prioritized:true});
        }        
        for (var id in master) {
            if (priority.indexOf(id) >= 0)
                continue;
            data.control.master.push({id:id, master:master[id]});
        }
        //console.log("master setuped "+data.control.master.length)        
    }

    return {

        setup: function(data) {
            data.control = {
                state: {
                    retained:{},
                    status:null,
                    revision:0
                },
                master:null,
                time:null,
                info:null
            };
            data.updated('master', 
                function(r) {
                    //console.log("master updated");
                    setMaster(data, r.data);
                    update(data);
                },
                function() {
                    data.control.master = null,
                    data.control.state.retained = null;
                    data.control.state.status = "master load error";
                    data.control.state.revision++;
                    data._update('data', data.control.state);
                    data._inspector(data.source.data);
                    for ( var i = 0 ; i < data.source.data.inspector.completed.length ; i++ )
                        data.source.data.inspector.completed[i](data.retained.data);
                });
            data.updated('info', 
                function(r) {
                    //console.log("info updated");
                    data.control.info = r,
                    update(data);
                },
                function() {
                    data.control.info = null,
                    data.control.state.retained = null;
                    data.control.state.status = "master load error";
                    data.control.state.revision++;
                    data._update('data', data.control.state);
                    data._inspector(data.source.data);
                    for ( var i = 0 ; i < data.source.data.inspector.completed.length ; i++ )
                        data.source.data.inspector.completed[i](data.retained.data);
                });
            data.updated('time', 
                function(r) {
                    console.log("time updated");
                    data.control.time = r;
                    update(data);
                },
                function() {
                    data.control.master = null,
                    data.control.state.retained = null;
                    data.control.state.status = "time load error";
                    data.control.state.revision++;
                    data._update('data', data.control.state);
                    data._inspector(data.source.data);
                    for ( var i = 0 ; i < data.source.data.inspector.completed.length ; i++ )
                        data.source.data.inspector.completed[i](data.retained.data);
                });
            data.load('master');
            data.load('info');
        },


        Binder: {
            time: function(conf, data, status, expanded_index) {
                var target = conf.request_divider && conf.request_divider.target;
                if ( !target )
                    return {data:data, status:status};
                var base = [];
                var div = [];
                for ( var i = 0 ; i < expanded_index.length ; i++ ) {
                    var e = expanded_index[i][target];
                    if ( div[e] === undefined ) 
                        div[e] = 0;
                    else
                        div[e]++;
                    base[i] = div[e];
                }

                var binded = {data:[], status:[]};
                for ( var i = 0 ; i < data.length ; i++ ) {
                    var index = base[i];
                    if ( !data[i] ) {
                        continue;
                    }
                    if ( binded.data[index] === undefined) {
                        binded.data[index] = data[i];
                    }
                    else {
                        for ( var key in data[i].data ) {
                            binded.data[index].data[key] = data[i].data[key];
                        }
                    }
                }
                var error = 0;
                binded.status = [];
                for ( var i = 0 ; i < status.length ; i++ ) {
                    var index = base[i];
                    var s = (status[i]===undefined?"":status[i]);
                    if ( status[i] !== undefined )
                        error++;
                    if ( binded.status[index] === undefined ) 
                        binded.status[index] = s;
                    else 
                        binded.status[index] += ","+s;
                }
                if ( !error )
                    binded.status[index] = null;
                if ( div.length == data.length ) {
                    binded.data = binded.data[0];
                    binded.status = binded.status[0];
                }
                return binded;
            }
        },

        loadTime: function(data, validtime) {
            const force = !data.conf.time.cache;
            data.load('time', {validtime: validtime}, force, ret => {
                // cacheが効いてるとtimeのupdatedが動作しないのでここでフォローする
                if (!force && data.control.time?.valid_time !== ret.valid_time) {
                data.control.time = ret;
                update(data);
            }
            });
        },

        //popup windowの表示状態をmasterに反映させる
        setSelectedPopup: function(data, key, flg) {
            for (let i = 0; i < data.control.master.length; i++) {
                let m = data.control.master[i];
                if (m.id === key) {
                    m.popup = flg;
                    break;
                }
            }
            update(data);
        }
    }
}());
/* eslint-enable */
